module.exports = __webpack_public_path__ + "static/assets/10aa2f52495a52d4ae59203c39127f15.svg";